import { selectAll } from "../utils/utils";
import Swiper from 'swiper/bundle';

export class Blog {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.teamCarouselContainer = selectAll("[data-blog-carousel]");
  }

  render() {
    this.blogCarousel();
  }

  blogCarousel = () => {
    for (var i = 0; i < this.teamCarouselContainer.length; i++) {
      new Swiper(this.teamCarouselContainer[i], {
        slidesPerView: 1.3,
        spaceBetween: 16,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        breakpoints: {
          780: {
            slidesPerView: 1.5,
            spaceBetween: 73,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          }
        }
      });
    };


  };
}